import React, { PropsWithChildren } from 'react'
import { cn } from '@/lib/utils'

import { Spinner } from './Spinner'

interface Props {
  isLoading: boolean
  modalView?: boolean
  fullWidth?: boolean
  className?: string
}

export const Loading: React.FC<PropsWithChildren<Props>> = ({
  isLoading,
  modalView = false,
  fullWidth = true,
  className,
  children,
}) => {
  return (
    <div className={cn('relative', fullWidth && 'h-full', className)}>
      {isLoading && (
        <div className='absolute inset-0 z-10 flex items-center justify-center'>
          <Spinner modal={modalView} />
        </div>
      )}
      <div className={cn(fullWidth && 'h-full', className, isLoading ? 'invisible' : 'visible')}>
        {children}
      </div>
    </div>
  )
}
